import { DateInput } from '@fullcalendar/core/datelib/env';

export class ExoStar {
    exoStartUserId: string;
    userId: string;
    licenseKey: string;
    activationCode: string;
    userStatus: number;
    userstatus: string;
    firstName: string;
    middleName: string;
    providerId: string;
    address1: string;
    address2: string;
    lastName: string;
    proofingStatus: number;
    licencekyUpdatedOn: Date;
    activeCodeUpdatedOn: Date;
    epcsStatus: number;
    expiryDate: number;
    createdBy: string;
    modifiedBy: string;
    createdOn: Date;
    modifiedOn: Date;
    remarks: string;
    proofingUrl: string;
    proofingMaxLimit: number;
    startDate: string;
    endDate: string;
    LicTransactionId: number;
    UserId: string;
    Notes: string;
    licId: number;
    isActive: boolean;
    maxSeats: number;
    availed: number;
    Used: number;
    isBulk: boolean;
    licenceKey: string;
    expirydatetime: Date;
    expirydates: string;
    dob: string;
    ssn: string;
    phone: string;
    emailId: string;
    fullName: string;
    NPI: string;
    providerName: string;
    notes: string;
    adminUserId: string;
    grantAccess: boolean;
    proofStatus: string;
    dueDate: Date;
    tokenType: string;
    DEA: string;
    licenseExpiry: string;
    SoftTokens: string;
    HardTokens: string;
    proofingStart: string;
    proofingEnd: string;
    proofingType: string;
    fullAddress: string;
    createdon: string;
    facilityId: number;
    type: string;
    otp: string;
    password: string;
    loggedInUser: string;
    status: string;
    response: string;
    comment: string;
    providerGrantAccess: boolean;
    revokeAdminUser: string;
    revokeStatus: boolean;
    isRevokeInitiated: boolean;
    isGrantInitiated: boolean;
    prescriptionLimit: number;
    dueDate1: string;
}
